const MODULE_NAME = 'ChangeLogModule';

export const APPEND_CHANGELOG_PAGE = `${MODULE_NAME}/APPEND_CHANGELOG_PAGE`;
export const LOCAL_APPEND_CHANGELOG_PAGE = 'APPEND_CHANGELOG_PAGE';
export const RESET_CHANGELOG = `${MODULE_NAME}/RESET_CHANGELOG`;
export const LOCAL_RESET_CHANGELOG = 'RESET_CHANGELOG';
